__turbopack_context__.v({
  "baseButton": "button-module-sass-module__MOa9Pq__baseButton",
  "button": "button-module-sass-module__MOa9Pq__button",
  "disabled": "button-module-sass-module__MOa9Pq__disabled",
  "loginButton": "button-module-sass-module__MOa9Pq__loginButton",
  "primary": "button-module-sass-module__MOa9Pq__primary",
  "secondary": "button-module-sass-module__MOa9Pq__secondary",
});
